import {Component, TextComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {gameState} from '../state/GameState.js';
import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';

export class Message {
    id: string;
    content: string;
    timeout: number;

    /**
     * @param text - the text of the message
     * @param timeout - the time in seconds after which the message will disappear, defaults to 5 seconds
     */
    constructor(text: string, timeout: number = 5) {
        this.id = Math.random().toString(36).substring(2);
        this.content = text;
        this.timeout = timeout;
    }

    toString(): string {
        return this.content;
    }
}

class MessageConsole extends NotifyPropertyChanged {
    messages: Message[] = [];

    private _timecounter = 0;
    private _defaultTimeout = 5;

    addMessage(content: string, timeout: number | null = null): void {
        this.messages.push(
            new Message(content, this._timecounter + (timeout ?? this._defaultTimeout))
        );

        this.notifyPropertyChanged('messages');
    }

    update(delta: number): void {
        this._timecounter += delta;

        // Remove messages that have timed out,
        // and call the notifyPropertyChanged if necessary
        for (let i = this.messages.length - 1; i >= 0; i--) {
            const message = this.messages[i];
            if (message.timeout > 0 && this._timecounter > message.timeout) {
                this.messages.splice(i, 1);
                this.notifyPropertyChanged('messages');
            }
        }
    }

    clear() {
        this.messages = [];
        this.notifyPropertyChanged('messages');
    }

    setDefaultTimeout(defaultTimeout: number) {
        this._defaultTimeout = defaultTimeout;
    }
}

export const messageConsole = new MessageConsole();

export class MessageController extends Component {
    static TypeName = 'message-controller';

    /**
     * Timeout for messages to disappear, in seconds.
     */
    @property.float(5.0)
    defaultTimeout!: number;

    start(): void {
        messageConsole.setDefaultTimeout(this.defaultTimeout);
    }

    update(delta: number): void {
        messageConsole.update(delta);
    }
}
